import {
    EnumCheckCredentialsResult,
    EnumInfoUTypes,
    EnumLoginSecureKeyTypes,
    EnumMFAMethods,
    EnumNotificationDeliveryOptions,
    EnumNotificationStatuses,
    EnumPopupShowStatuses,
    HistoryEventTypesEnum,
    EnumSystemOptionDataTypes, EnumUserLoginStatus
} from '@core/framework/sysenums.enum';

export class BaseState { }
export class BaseEntity { 
    EntryID: number;
    TypeName?: string; 
 }
    
export class BaseResponse {
    IsSuccess: boolean;
    ResponseCode: number;
    ResponseMessage: string;
    ResponseExtendedMessage: string;
}

export class KeyValueEntity extends BaseEntity {
    Key: string;
    Value: string;
}

export class GenericListEntity extends BaseEntity {
    constructor(
        public Value?: string,
        public Text?: string,
        public Description?: string,
        public SortOrder?: number
    ) { super(); }
}


//Response types prototypes - for single entity, list of entities, and single data field response
export class BaseEntityResponse<TEntity extends BaseEntity> extends BaseResponse { Entity: TEntity; }
export class BaseEntitiesResponse<TEntity extends BaseEntity> extends BaseResponse { Entities: TEntity[] }
export class BaseDataResponse<TData> extends BaseResponse { Data: TData; }

export class CredentialsCheckResponse {
    public CredentialID: number;
    public CredentialType: number;
    public CheckResult: EnumCheckCredentialsResult;
    public CheckResultMessage: string;
    public UserName: string;
}

export class SessionEntity extends BaseEntity {
    CheckResult: EnumCheckCredentialsResult
    CheckResultMessage: string
    SessionID: string
    CredentialID: number
    DisplayUserName: string
    DisplayUserDescription: string
    UserInfo: any;
}

export class UserActivityStatus extends BaseEntity {
    DisplayUserName: string;
    LastUseDate: Date;
    IsOnline: boolean;
}


export class LoginParams extends BaseEntity {
    public UserName: string
    public SecureKey: string
    public SecureKeyType: EnumLoginSecureKeyTypes;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Language: string;
    public Password: string;
    public NewPassword: string;
    public TaxNumber: string;
}

export class PasswordRecoveryParams extends BaseEntity {
    public UserName: string
    public Address: string;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Token: string;
    public Language: string;
    public NewPassword: string;

}

export class CompanyInfo extends BaseEntity {
    public DecimalSeparator: string
    public ThousandsSeparator: string

    public NumberGeneral: string
    public NumberPercent: string
    public NumberPrice: string
    public NumberQuantity: string
    public NumberRate: string
    public NumberSum: string

    public DateFormatShort: string
    public DateFormatLong: string
    public DateFormatCompact: string
    public DateFormatFull: string
    public TimeFormatLong: string
    public TimeFormatShort: string

    public CurrencyLocal: string
    public CurrencySystem: string

    public VatPercent: number;
    public IsVatLiable: boolean;

    public ServerVersion: string;
    public ClientVersion: string;
    public SBOVersion: string;
}

export class ClientException extends BaseEntity {
    Type: string
    Message: string
    StackTrace: string

    Device: string;
    DeviceType: string
    Browser: string
    BrowserVersion: string
    OS: string
    OSVersion: string
}

export class DataGroupInfo extends BaseEntity {
    constructor(
        public Name: string,
        public Value: string,
        public TotalRows = 0,
    ) { super(); }
}

export class ItemPriceInfo extends BaseEntity {
    Price: number;
    DiscountPercent: number;
    Currency: string;
}


export class Media extends BaseEntity {
    ImageBase64: string;
    ImageBytes: number[];
    VideoBytes: number[];
    VideoDataUrl: any;
}

export class WebAPICredential extends BaseEntity {
    UserName: string;
    Password: string;
    Type: number;
    IsActive: boolean = true;
    IsPendingWelcome: boolean;
    MFAMethod: EnumMFAMethods;
    IsRestrictByIP: boolean;
    IsExcludeFromMFA: boolean;

    WebAPIAllowedIPs: WebAPIAllowedIP[];
}

export class WebAPIAllowedIP extends BaseEntity {
    CredentialID: number;
    IPRangeStart: string;
    IPRangeEnd: string;
}

export class WebAPICredentialInfo extends BaseEntity {
    UserName: string;
    Type: number;
    IsActive: boolean;
    IsPendingWelcome: boolean;
    MFAMethod: EnumMFAMethods
    IsRestrictByIP: boolean;
    IsExcludeFromMFA: boolean;
    IsLockedOut: boolean;
    IsSupportedUserWelcome: boolean;

    WebAPIAllowedIPs: WebAPIAllowedIP[];
}

export class CredentialExternalInfo extends BaseEntity {
    DisplayUserName: string;
    DisplayUserDescription: string;
    Phone: string;
    Email: string;
}

export class AttachedFile extends BaseEntity {
    public Name: string;
    public Extension: string;
    public NewFile: File;
    public Size: number;
    public IconStyle: string;
    public IsDisplayedAsImage: boolean;
    public Date: Date;
}

export class UploadFile extends BaseEntity {
    public Name: string;
    public Type: string;
    public Data: any;
    public Buffer: ArrayBuffer;
    public File: File;
}

export class CommonSettingEntity extends BaseEntity {
    public Name: string;
    public Description: string;
}

export class Notification extends BaseEntity {
    public Subject: string;
    public Body: string;
    public CreatedBy: number;
    public CreatedDate: Date;
    public FromAddress: string;
    public FromDisplayAddress: string;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Status: EnumNotificationStatuses;
    public Address: string;
    public CCAddress: string;
    public BccAddress: string;
    public ExternalReferenceID: any;
    public NotificationTemplateID: number;
    public FailureDescription: string;
    public RelatedObjectType: string;
    public RelatedObjectID: number;
    public ReadDate: Date;
    public IsRead: boolean;
    public TargetCredentialID: number;
    public IsAutomatic: boolean;
    public PopupShowStatus: EnumPopupShowStatuses;
    public TargetCredentialName: string;
    public CreatedByName: string;
    public NotificationTemplateName: string;
}

export class NotificationListParams extends BaseEntity {
    public Address: string;
    public UntilDate: Date;
    public FromDate: Date;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public Template: string;
}

export class NotificationServer extends BaseEntity {
    public SMTPServer: string;
    public SMTPPort: number;
    public SMTPUserName: string;
    public SMTPPassword: string;
    public SMTPUseSSL: boolean;
    public SMSEndpoint: string;
    public SMSUserName: string;
    public SMSPassword: string;
    public SMSToken: string;
    public SMSEndPointIsInforU: EnumInfoUTypes;
}

export class NotificationTemplate extends BaseEntity {
    public Name: string;
    public Language: string;
    public Subject: string;
    public HTMLBody: string;
    public FromEmailDisplay: string;
    public FromEmail: string;
    public FromPhone: string;
    public SMSBody: string;
    public PushMessageBody: string;
    public NotificationServerID: number;
}

export class PushMessageListParams extends BaseEntity {
    public IsLoadAllNotifications: boolean;
}

export class NotificationTestParams extends BaseEntity {
    public NotificationServerID: number;
    public DeliveryOption: EnumNotificationDeliveryOptions;
    public FromAddress: string;
    public Address: string;
}

export class UserLoginParams extends BaseEntity {
    public DateFrom: Date;
    public DateTo: Date;
    public Status: EnumUserLoginStatus;
    public CredentialType: number;
    public CredentialID: number;
}

export class UserLogin extends BaseEntity {
    public ClientUserName: string;
    public CredentialType: number;
    public StartDate: Date;
    public LastUseDate: Date;
    public Status: EnumUserLoginStatus;
    public ClientIPAddress: string;
}

export class UserNameCheckResponse extends BaseEntity {
    public IsExists: boolean;
    public HasPhone: boolean;
    public HasEmail: boolean;
}

export class SaveCredentialsParams extends BaseEntity {
    public CredentialID: number;
    public UserName: string;
    public Password: string;
    public Type: number;
    public IsActive: boolean;
    public MFAMethod: EnumMFAMethods;
    public IsRestrictByIP: boolean;
    public IsExcludeFromMFA: boolean;
    public WebAPIAllowedIPs: WebAPIAllowedIP[];
}

export class SystemOptionEntity extends BaseEntity {
    public OptionName: string;
    public Value: string;
    public SectionInfo: string;
    public IsServer: boolean;
    public IsClient: boolean;
    public ModuleName: string;

    public SectionIndex: number;
    public ValueNumber: number;
    public ValueBoolean: boolean;
    public IsDeleted: boolean;
    public DataType: EnumSystemOptionDataTypes;
    public DefaultIsClient: boolean;
}

export class CredentialInfo extends BaseEntity {
    public Value: number;
    public Text: string;
}

export class WebAPIRequestListParams extends BaseEntity {
    CredentialID: number;
    ModuleName: string
    Controller: string;
    Action: string;
    DateFrom: Date;
    DateTo: Date;
}

export class WebAPIRequest extends BaseEntity {
    SessionID: number;
    DateTime: Date;
    Duration: number;
    Controller: string;
    Action: string;
    ModuleName: string;
    Method: string;
    QueryString: string;
    Body: string;
    Response: string;
    StatusCode: number;
}

export class HistoryChangesSet extends BaseEntity {
    public CreatedDate: Date;
    public CreatedBy: number;
    public Changeset: number;
    public CredentialName: string;
    public HistoryChanges: HistoryChangeDetails[];
    public HistoryLineChanges: HistoryChangeDetails[];
}

export class HistoryChangeDetails extends BaseEntity {
    public Action: HistoryEventTypesEnum;
    public FieldName: string;
    public NewValue: string;
    public OldValue: string;
    public EntityType: string;
    public EntityEntryID: number;
    public EntityLineID: number;
    public Name: string;
}